"use strict";
/**
 * (C) Copyright 2023, Scaleton Labs LLC
 *
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractType = void 0;
var ContractType;
(function (ContractType) {
    ContractType[ContractType["VAULT"] = 1] = "VAULT";
    ContractType[ContractType["POOL"] = 2] = "POOL";
    ContractType[ContractType["LIQUIDITY_DEPOSIT"] = 3] = "LIQUIDITY_DEPOSIT";
})(ContractType || (exports.ContractType = ContractType = {}));
//# sourceMappingURL=ContractType.js.map